module.exports = __webpack_public_path__ + "static/media/speech.8a859e87.jpg";